import { render, staticRenderFns } from "./VuesticPopover.vue?vue&type=template&id=17a1c05a&scoped=true&"
import script from "./VuesticPopover.vue?vue&type=script&lang=js&"
export * from "./VuesticPopover.vue?vue&type=script&lang=js&"
import style0 from "./VuesticPopover.vue?vue&type=style&index=0&id=17a1c05a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17a1c05a",
  null
  
)

component.options.__file = "VuesticPopover.vue"
export default component.exports